module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<a\n    ng-href="{{cdLnkCtrl.url}}"\n    target="{{cdLnkCtrl.target}}"\n    ng-if="cdLnkCtrl.hasInfra3DPermission"\n    >{{cdLnkCtrl.label}}</a\n>\n';

}
return __p
}